// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/move-assignment-to-lesson-async-request-schema',
  type: 'object',
  required: ['id', 'lessonId'],
  properties: {
    id: {
      type: 'integer',
    },
    lessonId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
